export const RoutingRulesPaths = {
    rules: "rules",
    ruleByType: "rules/:ruleTypeSlug",
    ruleByTypeVersion: "rules/:ruleTypeSlug/:version",
    queues: "queues",
    attributes: "attributes",
    createQueue: "queues/:queueId",
} as const;
